import React from "react"
import styles from "./aifordefensejoinus.css"

const AIforDefenseJoinus = (props) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" href="https://event.on24.com/wcc/r/3147380/4536A132820893261AF173F3BF5A6363" target="_blank">REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default AIforDefenseJoinus